var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value.email)?_c('t-icon-label',{staticClass:"email m-b-h",attrs:{"icon":"el-icon-icon-envelop"},nativeOn:{"click":function($event){return _vm.handleMailClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.value.email))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }